'use client';

import type { JobTone } from '@shared/all/helpers/runningJobs';

// Web's palette for the tones in shared/all/helpers/runningJobs. Its own module
// because both painters need it and importing one from the other would close a
// cycle: RunningJobs → useJobTerminal → the terminal window → the switcher.
const TONE: Record<JobTone, string> = {
  ai: 'bg-sky-400',
  bare: 'bg-emerald-400',
  quiet: 'bg-yellow-400',
  attention: 'bg-amber-400',
  review: 'bg-violet-400',
  error: 'bg-rose-400',
  idle: 'bg-zinc-500'
};

/** One dot throughout: it pulses while the work runs and sits still once it is
 *  waiting or done. A spinner read as "loading", which is the wrong idea for a
 *  session that is simply alive. */
const JobIndicator = ({
  tone,
  working
}: {
  tone: JobTone;
  working: boolean;
}) => (
  <span className="flex size-3 shrink-0 items-center justify-center">
    <span
      className={`size-[6px] rounded-full ${TONE[tone]} ${
        working ? 'animate-pulse' : ''
      }`}
    />
  </span>
);

export default JobIndicator;
